import { apiReferenceConfigurationSchema as o } from "@scalar/types/api-reference";
import { inject as e, computed as n } from "vue";
const r = Symbol(), f = () => e(
  r,
  n(() => o.parse({}))
);
export {
  r as CONFIGURATION_SYMBOL,
  f as useConfig
};
